import { render, staticRenderFns } from "./ModalEditStudents.vue?vue&type=template&id=eb2d04a8&scoped=true"
import script from "./ModalEditStudents.vue?vue&type=script&lang=js"
export * from "./ModalEditStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2d04a8",
  null
  
)

export default component.exports